import axios, { type AxiosInstance } from 'axios'

const ACCOUNT_ID_RAW = import.meta.env.VITE_CHATWOOT_ACCOUNT_ID ?? '1'
const API_BASE = import.meta.env.VITE_CHATWOOT_API_BASE ?? '/api'
const KANBAN_API_BASE =
  import.meta.env.VITE_KANBAN_API_BASE ?? '/api/kanban'

export const ACCOUNT_ID = Number(ACCOUNT_ID_RAW)

// Cliente "scoped" para tudo dentro de /api/v1/accounts/{id}
export const chatwoot: AxiosInstance = axios.create({
  baseURL: `${API_BASE}/v1/accounts/${ACCOUNT_ID}`,
  headers: { 'Content-Type': 'application/json' },
})

// Cliente para endpoints fora da scope de account (ex.: /auth/sign_in, /profile, /agents)
export const chatwootAuth: AxiosInstance = axios.create({
  baseURL: '/auth',
  headers: { 'Content-Type': 'application/json' },
})

// Cliente para o backend kanban_api (config dinâmica de stages, visibility, etc)
export const kanbanApi: AxiosInstance = axios.create({
  baseURL: KANBAN_API_BASE,
  headers: { 'Content-Type': 'application/json' },
})

let currentToken: string | null = null

export function setToken(token: string | null): void {
  currentToken = token
}

function injectToken(config: { headers: { set: (k: string, v: string) => void } }) {
  if (currentToken) {
    config.headers.set('api_access_token', currentToken)
  }
  return config
}

chatwoot.interceptors.request.use((config) => {
  return injectToken(config) as typeof config
})
kanbanApi.interceptors.request.use((config) => {
  return injectToken(config) as typeof config
})

// Evento global emitido em 401 — o auth store escuta e faz logout/redirect.
// Desacopla axios do Pinia (evita ciclo de imports). Aplicado em ambos os
// clients autenticados.
function handle401(error: { response?: { status?: number } }) {
  if (error?.response?.status === 401) {
    window.dispatchEvent(new CustomEvent('chatwoot:unauthorized'))
  }
  return Promise.reject(error)
}
chatwoot.interceptors.response.use((r) => r, handle401)
kanbanApi.interceptors.response.use((r) => r, handle401)
